async function updateCart() {
  try {
    const updatedCart = await fetchUpdatedCart();
    updateProgressBar(updatedCart);
    bindQtyButtons(); // Genbind knapperne efter opdatering af layoutet
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  bindQtyButtons(); // Sørg for at binde knapperne først
  updateCart();     // Opdater vognen derefter
});

function bindQtyButtons() {
  // Bind event listeners til plus- og minus-knapper
  document.querySelectorAll('.qty-button.qty-minus, .qty-button.qty-plus').forEach(button => {
    button.addEventListener('click', function() {
      // Tilføj en lille forsinkelse før opdatering
      setTimeout(() => {
        updateCart(); // Opdater vognen hver gang en knap klikkes
      }, 1000); // Forsinkelse på 500 millisekunder
    });
  });

  // Bind event listeners til "remove" links
  document.querySelectorAll('.cart-item__actions .remove').forEach(removeLink => {
    removeLink.addEventListener('click', function(event) {
      event.preventDefault(); // Forhindre standard navigationsadfærd
      fetch(removeLink.href, { method: 'GET' }) // Send GET-anmodning til remove link
        .then(() => {
          setTimeout(() => {
            updateCart(); // Opdater vognen efter fjernelse af produktet
          }, 1000); // Forsinkelse på 1000 millisekunder
        })
        .catch(error => console.error('Error removing item:', error));
    });
  });
}

async function fetchUpdatedCart() {
  const response = await fetch('/cart.js?' + new Date().getTime());
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return await response.json();
}

function updateProgressBar(updatedCart) {
  // Opdater selektoren til den nye klasse
  var progressFill = document.querySelector('.cart-progress-alt__fill');
  var milestones = document.querySelectorAll('.milestone-alt');
  var totalValue = 200000; // Total value for the progress bar
  var subtotalPrice = updatedCart.items_subtotal_price;
  
  var progressPercentage = Math.min(subtotalPrice / totalValue * 100, 100);
  progressFill.style.width = progressPercentage + '%';

  console.log('progressFill.style.width', progressFill);
  console.log('progressPercentage:', progressPercentage + '%');

  // Opdater milestones status og position
  milestones.forEach(function(milestone) {
    var milestoneValue = parseInt(milestone.dataset.value, 10);
    var percentage = (milestoneValue / totalValue) * 100;
    
    milestone.style.left = `calc(${percentage}% - 24px)`; // Juster positionen af ikonet

    if (subtotalPrice >= milestoneValue) {
      milestone.classList.add('reached');
    } else {
      milestone.classList.remove('reached');
    }
  });
}